// const FETCH_ALL_TICKETS_WITH_FILTERS = ODIN_API_PREFIX + "/tickets/all";

import { IOdinService } from "./IOdinService"
import { IFetchAllTicketsWithFiltersReqParams } from "./OdinServiceModels"
import ApiUtils from "../ApiUtils"
import { ODIN_NAMESPACE } from "../../constants"
import { getOdinTenantId } from "../../utils/helpers"

const ODIN_API_KEY = window.location.hostname.includes("synapse.curefit.co") ? "2b450f42-3bfe-41fa-b6aa-83fbc058f851" : "synapse-stage-access"

const OdinUrl = {
	fetchAllTicketsWithFilters: "/tickets/all",
	copyTickets: `/tickets/copy?apiKey=${ODIN_API_KEY}`,
}
export default class OdinServiceApis implements IOdinService {
	getServiceUrl = (url: string) => "/odin" + url
	fetchAllTicketsWithFilters = (params: IFetchAllTicketsWithFiltersReqParams): Promise<any> => {
		return ApiUtils.post(this.getServiceUrl(OdinUrl.fetchAllTicketsWithFilters), params, {
			X_NAMESPACE: ODIN_NAMESPACE,
			X_TENANT_ID: getOdinTenantId(), // stage: 15, prod/alpha: 12
		})
	}

	copyTickets = (params: any): Promise<any> => {
		return ApiUtils.post(this.getServiceUrl(OdinUrl.copyTickets), params, {
			X_NAMESPACE: ODIN_NAMESPACE,
			X_TENANT_ID: getOdinTenantId(), // stage: 15, prod/alpha: 12
		})
	}
}
